import app from 'app';
import ready from 'utils/ready';

import collection from './collection/main';
import filterResets from './collection/filter-resets';
import priceSlider from './collection/price-slider';

app.add({
  collection,
  filterResets,
  priceSlider,
});

ready(app.mount);
